/**
 *  @class
 *  @function FacetsToggle
 */
class FacetToggle extends HTMLElement {

  constructor() {
    super();
    this.init();
  }
  init() {
    this.drawer = document.getElementById('Facet-Drawer');
    this.container = this.closest('.facets--bar-sticky');

    // Add functionality to buttons
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
    });
    if (this.container) {
      this.enableSticky();
    }

  }
  enableSticky() {
    let rootMargin = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 1;
    this.observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle('is-pinned', e.intersectionRatio <= 1 && e.intersectionRatio > 0);
      },
      {
        threshold: [1],
        rootMargin: `-${rootMargin}px 0px 0px 0px`
      }
    );

    this.observer.observe(this.container);
  }

}
customElements.define('facet-toggle', FacetToggle);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onContinueSellingToggle = this.onContinueSellingToggle.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.id === 'compare_toggle' || event.target.hasAttribute('data-continue-selling-toggle')) {
        return;
      }
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    // Add event listener for continue selling toggle
    const continueSellingToggle = this.querySelector('[data-continue-selling-toggle]');
    if (continueSellingToggle) {
      console.log('[Continue Selling Filter] Toggle found, attaching event listener');
      continueSellingToggle.addEventListener('change', this.onContinueSellingToggle);
      // Initialize on page load if checked
      if (continueSellingToggle.checked) {
        console.log('[Continue Selling Filter] Toggle is checked on page load, applying filter');
        this.onContinueSellingToggle({ target: continueSellingToggle });
      } else {
        console.log('[Continue Selling Filter] Toggle is unchecked on page load');
      }
    } else {
      console.log('[Continue Selling Filter] Toggle not found in this form');
    }
    
    // Attach event listener to remove button if it exists
    const removeButton = document.querySelector('.js-continue-selling-remove');
    if (removeButton) {
      console.log('[Continue Selling Filter] Remove button found, attaching event listener');
      removeButton.addEventListener('click', (event) => {
        event.preventDefault();
        console.log('[Continue Selling Filter] Remove button clicked');
        const allToggles = document.querySelectorAll('[data-continue-selling-toggle]');
        allToggles.forEach(toggle => {
          toggle.checked = false;
          const changeEvent = new Event('change', { bubbles: true });
          toggle.dispatchEvent(changeEvent);
        });
      });
    }
  }
  
  onContinueSellingToggle(event) {
    const isChecked = event.target.checked;
    console.log('[Continue Selling Filter] Toggle changed:', isChecked);
    
    const productItems = document.querySelectorAll('.product-item');
    console.log('[Continue Selling Filter] Total products found:', productItems.length);
    
    // Sync both toggles (desktop and mobile)
    const allToggles = document.querySelectorAll('[data-continue-selling-toggle]');
    allToggles.forEach(toggle => {
      if (toggle !== event.target) {
        toggle.checked = isChecked;
      }
    });
    
    // Show/hide active facets badge
    const activeBadge = document.querySelector('[data-continue-selling-active-badge]');
    if (activeBadge) {
      if (isChecked) {
        activeBadge.style.display = '';
        console.log('[Continue Selling Filter] Showing active facets badge');
      } else {
        activeBadge.style.display = 'none';
        console.log('[Continue Selling Filter] Hiding active facets badge');
      }
    }
    
    let visibleCount = 0;
    let hiddenCount = 0;
    
    productItems.forEach(item => {
      // Skip promotion columns and loading overlays
      if (item.classList.contains('promotion-column') || item.classList.contains('loading-overlay')) {
        return;
      }
      
      const hasContinueSelling = item.getAttribute('data-continue-selling') === 'true';
      const productHandle = item.getAttribute('data-product-handle');
      
      if (isChecked) {
        // Show only products with continue selling enabled
        if (!hasContinueSelling) {
          item.style.display = 'none';
          hiddenCount++;
          console.log('[Continue Selling Filter] Hiding product:', productHandle);
        } else {
          item.style.display = '';
          visibleCount++;
          console.log('[Continue Selling Filter] Showing product:', productHandle);
        }
      } else {
        // Show all products
        item.style.display = '';
        visibleCount++;
      }
    });
    
    console.log('[Continue Selling Filter] Visible products:', visibleCount, 'Hidden products:', hiddenCount);
    
    // Show/hide empty state if no products match
    const emptyState = document.querySelector('.collection-empty--continue-selling');
    const productGrid = document.querySelector('#product-grid');
    
    if (isChecked && visibleCount === 0) {
      if (emptyState) {
        emptyState.style.display = '';
        console.log('[Continue Selling Filter] Showing empty state - no products match');
      }
      if (productGrid) {
        productGrid.classList.add('collection--empty');
      }
    } else {
      if (emptyState) {
        emptyState.style.display = 'none';
      }
      if (productGrid && !productGrid.querySelector('.collection-empty:not(.collection-empty--continue-selling)')) {
        productGrid.classList.remove('collection--empty');
      }
    }
    
    // Update product count if element exists
    this.updateProductCount();
  }
  
  updateProductCount() {
    const visibleProducts = Array.from(document.querySelectorAll('.product-item')).filter(item => {
      return item.style.display !== 'none' && !item.classList.contains('promotion-column');
    }).length;
    console.log('[Continue Selling Filter] Updating product count to:', visibleProducts);
    
    const countElements = document.querySelectorAll('.thb-filter-count .facets__label, .mobile-filter-count .facets__label');
    
    if (countElements.length > 0 && visibleProducts > 0) {
      countElements.forEach(el => {
        const originalText = el.textContent;
        // Try to update count if it's in a standard format
        const countMatch = originalText.match(/(\d+)/);
        if (countMatch) {
          el.textContent = originalText.replace(/\d+/, visibleProducts);
          console.log('[Continue Selling Filter] Updated count element:', el.textContent);
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const collectionElement = container.querySelector('.collection');
    
    // Store continue selling toggle state before updating
    const continueSellingToggle = document.querySelector('[data-continue-selling-toggle]:checked');
    const wasContinueSellingActive = continueSellingToggle ? continueSellingToggle.checked : false;
    console.log('[Continue Selling Filter] Product grid updating, was filter active:', wasContinueSellingActive);
    
    container.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    // Re-apply continue selling filter if it was active
    if (wasContinueSellingActive) {
      const newToggle = document.querySelector('[data-continue-selling-toggle]');
      if (newToggle) {
        console.log('[Continue Selling Filter] Re-applying filter after AJAX update');
        newToggle.checked = true;
        const form = newToggle.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        if (form && form.onContinueSellingToggle) {
          // Small delay to ensure DOM is ready
          setTimeout(() => {
            form.onContinueSellingToggle({ target: newToggle });
          }, 100);
        }
      } else {
        console.log('[Continue Selling Filter] Toggle not found after AJAX update');
      }
    } else {
      // Make sure empty state is hidden if filter is not active
      const emptyState = document.querySelector('.collection-empty--continue-selling');
      const productGrid = document.querySelector('#product-grid');
      if (emptyState) {
        emptyState.style.display = 'none';
      }
      if (productGrid) {
        productGrid.classList.remove('collection--empty');
      }
    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const currentElement = document.querySelector(selector);
      
      // Preserve continue selling badge state before updating
      const continueSellingBadge = currentElement.querySelector('[data-continue-selling-active-badge]');
      const wasContinueSellingActive = continueSellingBadge && continueSellingBadge.style.display !== 'none';
      console.log('[Continue Selling Filter] Preserving badge state:', wasContinueSellingActive);
      
      currentElement.innerHTML = activeFacetsElement.innerHTML;
      
      // Re-attach continue selling badge if it was active
      const newBadge = currentElement.querySelector('[data-continue-selling-active-badge]');
      if (newBadge) {
        if (wasContinueSellingActive) {
          newBadge.style.display = '';
          console.log('[Continue Selling Filter] Badge restored after AJAX update');
        } else {
          newBadge.style.display = 'none';
        }
        // The FacetRemove class will handle the event listener via connectedCallback
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Debug: Log continue selling status for all products on page load
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const productItems = document.querySelectorAll('.product-item');
    console.log('[Continue Selling Filter] Page loaded. Total products:', productItems.length);
    
    let continueSellingCount = 0;
    productItems.forEach(item => {
      const hasContinueSelling = item.getAttribute('data-continue-selling') === 'true';
      const productHandle = item.getAttribute('data-product-handle');
      
      if (hasContinueSelling) {
        continueSellingCount++;
        console.log('[Continue Selling Filter] Product with continue selling:', productHandle);
      }
    });
    
    console.log('[Continue Selling Filter] Products with continue selling enabled:', continueSellingCount, 'out of', productItems.length);
    
    // Initialize remove button event listener
    const removeButton = document.querySelector('.js-continue-selling-remove');
    if (removeButton) {
      console.log('[Continue Selling Filter] Remove button found on page load');
      // Check if toggle is checked and show badge accordingly
      const toggle = document.querySelector('[data-continue-selling-toggle]:checked');
      if (toggle) {
        removeButton.style.display = '';
      } else {
        removeButton.style.display = 'none';
      }
    }
  }, 500);
});

/**
 *  @class
 *  @function Facetremove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.attachRemoveListeners();
  }
  
  attachRemoveListeners() {
    this.querySelectorAll('a').forEach((item) => {
      // Skip the continue selling remove button - handle it separately
      if (item.classList.contains('js-continue-selling-remove')) {
        // Remove existing listener if any
        const newItem = item.cloneNode(true);
        item.parentNode.replaceChild(newItem, item);
        
        newItem.addEventListener('click', (event) => {
          event.preventDefault();
          console.log('[Continue Selling Filter] Remove button clicked from FacetRemove');
          // Uncheck all continue selling toggles
          const allToggles = document.querySelectorAll('[data-continue-selling-toggle]');
          allToggles.forEach(toggle => {
            toggle.checked = false;
            // Trigger the change event to update the filter
            const changeEvent = new Event('change', { bubbles: true });
            toggle.dispatchEvent(changeEvent);
          });
        });
      } else {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (form && form.onActiveFilterClick) {
            form.onActiveFilterClick(event);
          }
        });
      }
    });
  }
  
  connectedCallback() {
    // Re-attach listeners when element is reconnected (after AJAX updates)
    this.attachRemoveListeners();
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.compareToggle = this.querySelector('#compare_toggle');
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
    return false;
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);